import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { Booking, Meta } from 'utils/types';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';

interface Result {
  data: Booking;
  meta: Meta;
}

export default function useGetBookingEvent(id: string) {
  const { state } = useProvider();
  const args = state;
  return useQuery<Booking, Error>({
    queryKey: [c.BOOKING_EVENT, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get({
        url: `api/public/calendar/bookings/events/${id}`,
      });

      return data?.data;
    },
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
